import React from 'react';
import { Snackbar } from '@mui/material';
import { colors } from '../../theme/color-palette';
import PropTypes from 'prop-types';

function SnackBarWrapper(props) {
	const {
		variant,
		open = true,
		hideDuration = 5000,
		message,
		action,
		onClose,
	} = props;
	const { ERROR_MIN, SUCCESS_MIN, ERROR_HIGH, SUCCESS_HIGH } = colors;

	const colorCoding = {
		error: {
			BACKGROUND_COLOR: ERROR_MIN,
			COLOR: ERROR_HIGH,
		},
		success: {
			BACKGROUND_COLOR: SUCCESS_MIN,
			COLOR: SUCCESS_HIGH,
		},
	};

	return (
		<Snackbar
			data-test-id="confirmation-snackbar"
			data-testid="confirmation-snackbar"
			sx={{
				'& .MuiPaper-root': {
					backgroundColor: colorCoding[variant]['BACKGROUND_COLOR'],
					borderRadius: '4px',
					boxShadow:
						'0px 5px 10px 3px rgba(0, 0, 0, 0.15), 0px -1px 4px 0px rgba(0, 0, 0, 0.10)',
					color: colorCoding[variant]['COLOR'],
					padding: '0 16px',
				},
				'& .MuiSnackbarContent-message': {
					fontSize: '16px',
					padding: '16px 16px 16px 0',
				},
			}}
			open={open}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			autoHideDuration={hideDuration}
			onClose={onClose}
			message={message}
			action={action}
		/>
	);
}

SnackBarWrapper.propTypes = {
	variant: PropTypes.string.isRequired, // options: "success", "error"
	open: PropTypes.bool,
	hideDuration: PropTypes.number,
	message: PropTypes.string.isRequired,
	action: PropTypes.element,
	onClose: PropTypes.func,
};

export default SnackBarWrapper;
